const userMenu = {
  defaultName: "User",
  menu: {
    adminDashboard: "Admin Dashboard",
    dataSourcePortal: "Data Source Portal",
    browseDatasets: "Browse Datasets",
    dataRequests: "Your requests",
    myAccessRequests: "Requests to join a project",
    myProjects: "My Projects",
    backToProjects: "Back to Projects",
  },
};

export default userMenu;
